// src/encounter/intelligence/explain-card-classes.ts
//
// The Explain card's class names: Signal DS / Tailwind named utilities only (check-no-arbitrary-classes). Kept apart
// from the component so the component file exports components only (react-refresh).
/** Signal DS / Tailwind named classes only (no arbitrary values). Text styles (18f): title 13/600 (text-sm
 *  font-semibold), body 12/400 (text-xs), value 12/600 (text-xs font-semibold tabular-nums), meta (text-2xs: the DS
 *  has no 11px text utility today, so meta renders at 12px; graduation item). */
export const C = {
  // Round 18r rail card: 12/16 padding, 4px between lines, 1px border-card, the card radius, white.
  card: '@container flex flex-col gap-1 px-4 py-3 border border-border-card rounded-lg bg-surface-card text-text-primary text-xs',
  titleRow: 'flex items-baseline justify-between gap-2',
  title: 'm-0 text-sm font-semibold',
  meta: 'm-0 text-2xs font-normal text-text-secondary',
  count: 'm-0 text-xs font-normal tabular-nums',
  // Round 18r rules (sub-row rule, group label, Limits) use the design's surface line, #DCE5E9 = DS border-card.
  // Round 18r table: 4px under the Read lines; 12px between the column header and the first row, and between groups.
  results: 'mt-1 flex flex-col gap-3',
  rows: 'flex flex-col',
  // Round 18r column header over line 2 (Value · Lab flag · Ref range), always shown, in the line-2 columns: 14px line,
  // 2px above and below (18px).
  // One line always: at the 12px floor "Lab flag" is 2px wider than its 40px column and runs into the 4px gap, as the
  // design's 11px label does not need to.
  header: 'flex items-center gap-1 py-0.5 whitespace-nowrap text-2xs leading-3.5 font-normal text-text-secondary',
  row: 'flex flex-col gap-0.5 py-1.5',
  rowGroupStart: 'mt-3',
  // Ruling 1 Nov: the newest result's sub-row, 2px above and 6px below, with a 1px rule in the card padding (8px left of
  // the row) and its name cell indented 12px; every other cell stays in the row columns.
  subRow: 'relative flex flex-col gap-0.5 pt-0.5 pb-1.5',
  subRule: 'absolute -left-2 top-0.5 bottom-1.5 border-l border-border-card',
  subName: 'flex-1 min-w-0 pl-3 break-normal wrap-normal text-2xs leading-3.5 font-normal text-text-secondary',
  line1: 'flex items-baseline gap-2',
  // Round 18r grid: value 88 · flag 40 · range 1fr · trend 48, 4px between columns.
  line2: 'flex items-baseline gap-1',
  // Round 18r: line 1 (name, date) sits on a 14px line.
  name: 'flex-1 min-w-0 break-normal wrap-normal text-xs leading-3.5 font-normal',
  value: 'w-22 shrink-0 text-xs font-semibold tabular-nums',
  // T2/T6: the critical row's value is error-coloured and bold too (with the flag icon, never colour alone).
  valueCritical: 'w-22 shrink-0 text-xs font-semibold tabular-nums text-status-error',
  flag: 'w-10 shrink-0 text-xs font-semibold text-text-primary',
  flagCritical: 'w-10 shrink-0 inline-flex items-center gap-1 text-xs font-semibold text-status-error',
  flagPlain: 'w-10 shrink-0 text-xs font-normal text-text-secondary',
  range: 'flex-1 min-w-0 break-normal wrap-normal text-2xs text-text-secondary tabular-nums',
  date: 'shrink-0 text-right whitespace-nowrap text-2xs leading-3.5 text-text-secondary tabular-nums',
  spark: 'w-12 shrink-0 self-center flex justify-end items-center text-brand-primary',
  // Round 18r: the marker cell keeps line 1 on its 14px line (the 16px marker overflows it, as in the design).
  markerCell: 'w-5 h-3.5 shrink-0 flex items-center justify-end',
  // Round 18r: the source marker is always shown, in text-secondary.
  marker: 'inline-flex items-center justify-center w-5 h-4 p-0 border-0 bg-transparent text-text-secondary cursor-pointer',
  subnote: 'text-2xs font-normal text-text-secondary',
  subline: 'text-2xs font-normal text-text-secondary break-normal wrap-normal',
  subnoteCritical: 'text-xs font-semibold text-status-error',
  // Round 18r: brand links with no underline at rest (underline on hover and focus).
  linkButton: 'p-0 border-0 bg-transparent text-xs font-normal text-brand-primary no-underline hover:underline focus-visible:underline cursor-pointer',
  details: 'mt-1 p-2 rounded-sm bg-surface-tint-soft text-2xs text-text-secondary flex flex-col gap-1',
  hairline: 'm-0 my-1 border-0 border-t border-border-hairline',
  // Round 18r: "Open the results list" sits 6px under the results.
  openResults: 'self-start pt-1.5 px-0 pb-0 border-0 bg-transparent text-xs font-normal text-brand-primary no-underline hover:underline focus-visible:underline cursor-pointer',
  // Round 18r group label ("Problems"): a hairline above, 8px margin and padding over it, 2px under it.
  group: 'm-0 mt-2 pt-2 pb-0.5 border-0 border-t border-border-card text-2xs leading-4 font-normal text-text-secondary',
  // Round 18r not-found line: an 8px open circle, 8px gap, body text, 4px above and below.
  gap: 'flex items-center gap-2 py-1 text-xs leading-4 text-text-primary',
  gapMark: 'size-2 shrink-0 rounded-full border border-text-muted',
  // Round 18r Limits row: the whole row is the control, a hairline above, 6px over the text, chevron at the end.
  limits: 'flex w-full min-h-6 items-center gap-1 m-0 pt-1.5 px-0 pb-0 border-0 border-t border-border-card bg-transparent text-left text-2xs leading-4 font-normal text-text-secondary cursor-pointer',
  limitsStatic: 'flex w-full min-h-6 items-center gap-1 pt-1.5 border-0 border-t border-border-card text-2xs leading-4 text-text-secondary',
  lines: 'm-0 p-0 list-none flex flex-col gap-1',
  // Round 18r problem row: name (1fr) · code · marker (20), 8px apart, 6px above and below, 14px lines; 32px tall (the
  // design's 20px marker box plus the padding).
  problem: 'flex min-h-8 items-center justify-between gap-2 py-1.5',
  problemName: 'flex-1 min-w-0 text-xs leading-3.5',
  problemMeta: 'flex items-center gap-2 shrink-0',
  problemCode: 'text-2xs leading-3.5 text-text-secondary tabular-nums',
  footerRow: 'flex items-center justify-between gap-2 text-2xs text-text-secondary',
  stateLine: 'm-0 text-xs text-text-primary',
  checks: 'm-0 p-0 list-none',
  check: 'flex justify-between gap-2',
} as const;
